import { useTranslation } from 'react-i18next';

import { createCdnIcon } from 'src/designSystem/CdnIcon';
import SafeAreaTop from 'src/designSystem/SafeArea/SafeAreaTop';
import { usePostHogFeatureFlag } from 'src/hooks/usePostHogFeatureFlag';

const WarningIcon = createCdnIcon('warning.svg');

const ServiceIncidentBanner = () => {
  const { t } = useTranslation();
  const { value: isEnabled, loading } = usePostHogFeatureFlag(
    'device_service_incident_banner_enabled',
  );

  if (loading || !isEnabled) {
    return null;
  }

  return (
    <>
      <SafeAreaTop className="bg-warning-darkest" />
      <div
        data-testid="service-incident-banner"
        className="flex items-center justify-center gap-2 px-2.5 py-2 bg-warning-darkest"
      >
        <WarningIcon className="size-6 shrink-0 fill-structural-darkest stroke-structural-darkest" />
        <p className="text-sm font-bold text-primary-lightest leading-tight">
          {t('serviceIncident.defaultMessage')}
        </p>
      </div>
    </>
  );
};

export default ServiceIncidentBanner;
